import { render } from "./PasswordDialog.vue?vue&type=template&id=12beeb4c&scoped=true"
import script from "./PasswordDialog.vue?vue&type=script&lang=js"
export * from "./PasswordDialog.vue?vue&type=script&lang=js"

import "./PasswordDialog.vue?vue&type=style&index=0&id=12beeb4c&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12beeb4c"]])

export default __exports__